import { axiosInstance } from "./intreceptor";

class creditDeductionService {
  getRates = (comp_id) => {
    return axiosInstance
      .get("/credit_deduction/getrates", { params: { comp_id: comp_id } })
      .then((response) => {
        return response;
      })
      .catch((err) => {
        throw err;
      });
  };

  updateRates = (payload) => {
    return axiosInstance
      .post("/credit_deduction/updaterates", payload)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        throw err;
      });
  };
}

export default new creditDeductionService();
